import { Dialog } from "@mui/material";
import { ModalCloseButton } from "../../../Components/Molecules/ValutDialog";
import { CrossborderPayinContent, CROSSBORDER_PAYIN_FORM_ID } from "./CrossborderPayinContent";

const MODAL_PAPER_CLASS =
  "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[90vh] !w-full !max-w-3xl";

export const CrossborderPayinModal = ({ open, onClose, onRequestQuote }) => {
  const handleDialogClose = (_, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown
      fullWidth
      maxWidth="md"
      scroll="paper"
      PaperProps={{ className: MODAL_PAPER_CLASS }}
    >
      <div className="relative flex min-h-0 flex-1 flex-col">
        <ModalCloseButton onClick={onClose} className="absolute right-3 top-3 z-10" />

        <div className="flex-1 overflow-y-auto px-5 pb-4 pt-6 sm:px-6">
          <h2 className="pr-8 text-lg font-bold text-brand-dark dark:text-gray-100">Novo payin</h2>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Receba pagamentos internacionais na origem e credita na moeda de destino na conta Valut do cliente.
          </p>

          <div className="mt-4">
            <CrossborderPayinContent
              isActive={open}
              onRequestQuote={onRequestQuote}
              onClose={onClose}
            />
          </div>
        </div>

        <div className="mt-auto shrink-0 border-t border-gray-100 px-5 pb-5 pt-4 dark:border-brand-dark-border sm:px-6">
          <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <button
              type="submit"
              form={CROSSBORDER_PAYIN_FORM_ID}
              className="btn-primary w-full sm:w-auto"
            >
              Solicitar cotação
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
